import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { findAddressforGeolocation } from '../../dataSource/address/address.request'
import { TAG_SUGGEST } from '../analytics/analytics.tagids.constants'
import { getCurrentLocation } from '../../store/geolocation/geolocation.actions'
import { setGeolocationStatus } from '../../store/geolocation/geolocationSlice'
import { setStepFromAddress, setStepFromSuggestion } from '../../store/itinerary/itinerary.actions'
import { selectIsItineraryDepartureNow } from '../../store/itineraryOptions/itineraryTimeOptions.selectors'
import { GEOLOC_STATUS_BLOCKED } from '../../store/map/map.constants'
import { selectLocale } from '../../store/navigation/navigation.selectors'
import {
  BROWSER_STORAGE_ALLOW_DEFAULT_USER_POSITION,
  BROWSER_STORAGE_ALLOW_DEFAULT_USER_POSITION_FALSE,
  BROWSER_STORAGE_ALLOW_DEFAULT_USER_POSITION_TRUE,
  saveToLocalStorage
} from '../../utils/browserStorageService'
import { removeHtmlEmSpanAndITags, removeHtmlEmTags } from '../../utils/string'
import useConfigureAndSendTag from '../analytics/useConfigureAndSendTag'
import { isPE } from '../Device'
import BookinSearchExtension from '../itinerary/BookingSearchExtension'
import { getStepIdx, selectAllSteps } from '../itinerary/steps/steps.selectors'
import { useAction } from '../utils/react-redux'
import MyPosition from './MyPosition'
import SuggestContent from './SuggestContent'
import { SUGGEST_FROM_VALUES } from './suggest.constants'

const ItinerarySuggestContent = () => {
  const dispatch = useDispatch()
  const execSetStepFromSuggestion = useAction(setStepFromSuggestion)
  const execGetCurrentLocation = useAction(getCurrentLocation)
  const execSetStepFromAddress = useAction(setStepFromAddress)
  const configureAndSendTag = useConfigureAndSendTag()
  const steps = useSelector(selectAllSteps)
  const idx = useSelector(getStepIdx)
  const departureNow = useSelector(selectIsItineraryDepartureNow)
  const locale = useSelector(selectLocale)

  const onClick = suggest => {
    const { labels = [], address, type, subtype, from } = suggest
    const label = removeHtmlEmTags(address || labels.join(' '))
    const split_label = labels.map(removeHtmlEmSpanAndITags)

    if (from === SUGGEST_FROM_VALUES.favorites) {
      configureAndSendTag({
        type: TAG_SUGGEST,
        tagInfo: { type, subtype, from }
      })
    }

    BookinSearchExtension.openPopup({ steps, idx, departureNow })

    execSetStepFromSuggestion({
      suggest: {
        ...suggest,
        label,
        split_label
      }
    })
  }
  const onMyPositionClick = () => {
    configureAndSendTag({
      type: TAG_SUGGEST,
      tagInfo: { from: SUGGEST_FROM_VALUES.geolocation }
    })

    return Promise.resolve()
      .then(() => execGetCurrentLocation())
      .then(geolocation => findAddressforGeolocation({ ...geolocation, locale }))
      .then(response => {
        if (isPE()) {
          saveToLocalStorage(
            BROWSER_STORAGE_ALLOW_DEFAULT_USER_POSITION,
            BROWSER_STORAGE_ALLOW_DEFAULT_USER_POSITION_TRUE
          )
        }
        const address = response?.addresses?.[0]
        if (address) execSetStepFromAddress(address)
      })
      .catch(error => {
        dispatch(setGeolocationStatus(GEOLOC_STATUS_BLOCKED))
        if (isPE()) {
          saveToLocalStorage(
            BROWSER_STORAGE_ALLOW_DEFAULT_USER_POSITION,
            BROWSER_STORAGE_ALLOW_DEFAULT_USER_POSITION_FALSE
          )
        }
      })
  }

  return <SuggestContent positionComponent={<MyPosition onClick={onMyPositionClick} />} onClick={onClick} />
}

export default ItinerarySuggestContent
